import { render, staticRenderFns } from "./GameModalMenu.vue?vue&type=template&id=52c66433&scoped=true&"
import script from "./GameModalMenu.vue?vue&type=script&lang=js&"
export * from "./GameModalMenu.vue?vue&type=script&lang=js&"
import style0 from "./GameModalMenu.vue?vue&type=style&index=0&id=52c66433&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c66433",
  null
  
)

export default component.exports